(function () {
  class Jq3xTableScroller extends HTMLElement {
    connectedCallback() {
      this.scroller_el = this.querySelector("[data-jq3x-table-scroller]");
      this.thumb_el = this.querySelector("[data-jq3x-table-thumb]");
      this.prev_el = this.querySelector("[data-jq3x-table-prev]");
      this.next_el = this.querySelector("[data-jq3x-table-next]");
      this.track_el = this.querySelector("[data-jq3x-table-track]");
      if (!this.scroller_el) return;

      this.reduce_motion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      this.on_scroll = this.update_thumb.bind(this);
      this.on_prev = this.scroll_by_column.bind(this, -1);
      this.on_next = this.scroll_by_column.bind(this, 1);
      this.sync_and_update = this.throttle(this.sync_layout.bind(this), 100);

      this.scroller_el.addEventListener("scroll", this.on_scroll, { passive: true });
      if (this.prev_el) this.prev_el.addEventListener("click", this.on_prev);
      if (this.next_el) this.next_el.addEventListener("click", this.on_next);
      window.addEventListener("resize", this.sync_and_update, { passive: true });

      this.querySelectorAll("img").forEach((img) => {
        if (!img.complete) {
          img.addEventListener("load", this.sync_and_update, { once: true, passive: true });
        }
      });

      this.sync_layout();
    }

    disconnectedCallback() {
      if (this.scroller_el && this.on_scroll) {
        this.scroller_el.removeEventListener("scroll", this.on_scroll);
      }
      if (this.prev_el && this.on_prev) {
        this.prev_el.removeEventListener("click", this.on_prev);
      }
      if (this.next_el && this.on_next) {
        this.next_el.removeEventListener("click", this.on_next);
      }
      if (this.sync_and_update) {
        window.removeEventListener("resize", this.sync_and_update);
        this.querySelectorAll("img").forEach((img) => {
          img.removeEventListener("load", this.sync_and_update);
        });
      }
    }

    sync_layout() {
      this.sync_row_heights();
      this.update_thumb();
    }

    sync_row_heights() {
      const features = Array.from(this.querySelectorAll(".jq3x-table__feature"));
      const columns = Array.from(this.querySelectorAll(".jq3x-table__column"));
      const intro = this.querySelector(".jq3x-table__intro");
      const heads = columns
        .map((col) => col.querySelector(".jq3x-table__col-head"))
        .filter(Boolean);

      if (intro) intro.style.height = "";
      heads.forEach((el) => {
        el.style.height = "";
      });
      features.forEach((el) => {
        el.style.height = "";
      });
      columns.forEach((col) => {
        col.querySelectorAll(".jq3x-table__cell").forEach((el) => {
          el.style.height = "";
        });
      });

      let head_h = 0;
      heads.forEach((el) => {
        head_h = Math.max(head_h, el.offsetHeight);
      });
      if (head_h > 0) {
        heads.forEach((el) => {
          el.style.height = head_h + "px";
        });
        if (intro) intro.style.height = head_h + "px";
      }

      const row_count = Math.max(
        features.length,
        ...columns.map((col) => col.querySelectorAll(".jq3x-table__cell").length)
      );

      for (let i = 0; i < row_count; i++) {
        let max_h = features[i] ? features[i].offsetHeight : 0;
        const cells = columns
          .map((col) => col.querySelectorAll(".jq3x-table__cell")[i])
          .filter(Boolean);
        cells.forEach((el) => {
          max_h = Math.max(max_h, el.offsetHeight);
        });
        if (max_h <= 0) continue;
        const height_value = max_h + "px";
        if (features[i] && features[i].style.height !== height_value) {
          features[i].style.height = height_value;
        }
        cells.forEach((el) => {
          if (el.style.height !== height_value) el.style.height = height_value;
        });
      }
    }

    get_step_size() {
      const columns = this.querySelectorAll(".jq3x-table__column");
      if (columns.length >= 2) {
        const distance = columns[1].offsetLeft - columns[0].offsetLeft;
        if (distance > 0) return distance;
      }
      if (columns.length >= 1) {
        return columns[0].offsetWidth + 3;
      }
      return 100;
    }

    update_thumb() {
      if (!this.scroller_el || !this.thumb_el || !this.prev_el || !this.next_el) return;

      const scroller = this.scroller_el;
      const columns = this.querySelectorAll(".jq3x-table__column");
      const count = columns.length;
      const max_scroll = scroller.scrollWidth - scroller.clientWidth;

      let ratio = 1;
      if (max_scroll > 0 && count > 1) {
        const progress = Math.min(1, Math.max(0, scroller.scrollLeft / max_scroll));
        ratio = (progress * (count - 1) + 1) / count;
      }

      this.thumb_el.style.transform = "none";
      this.thumb_el.style.width = ratio * 100 + "%";
      this.prev_el.disabled = max_scroll <= 0 || scroller.scrollLeft <= 0;
      this.next_el.disabled = max_scroll <= 0 || scroller.scrollLeft >= max_scroll - 1;
    }

    scroll_by_column(direction) {
      if (!this.scroller_el) return;
      const max_scroll = this.scroller_el.scrollWidth - this.scroller_el.clientWidth;
      if (max_scroll <= 0) return;

      let target = this.scroller_el.scrollLeft + direction * this.get_step_size();
      if (target < 0) target = 0;
      if (target > max_scroll) target = max_scroll;

      this.scroller_el.scrollTo({
        left: target,
        behavior: this.reduce_motion ? "auto" : "smooth",
      });
    }

    throttle(fn, wait) {
      let timer = 0;
      const self = this;
      return function () {
        if (timer) return;
        timer = window.setTimeout(function () {
          timer = 0;
          fn.call(self);
        }, wait);
      };
    }
  }

  if (!customElements.get("jq3x-table-scroller")) {
    customElements.define("jq3x-table-scroller", Jq3xTableScroller);
  }
})();
